export default __webpack_public_path__ + "static/media/heart-coin-img.cb3c26af.webp";